import { Stack, Text } from '@ltvco/refresh-lib/theme';
import { ConfirmCancelModal } from '@ltvco/refresh-lib/v1';
import { useContext, useState } from 'react';

import { ChatContext } from 'components/ChatBV/context';

import {
  StyledSubscriptionSettingsPopover,
  StyledSubscriptionSettingsPopoverContainer,
  StyledSubscriptionSettingsPopoverTitleBox,
} from './components';

export const SubscriptionSettingsPopover = ({
  open,
  onClose,
  anchorEl,
  id,
}: {
  open: boolean;
  onClose: () => void;
  anchorEl: HTMLElement | null;
  id?: string;
}) => {
  const { handleUpgradePlanClick } = useContext(ChatContext);
  const [isConfirmCancelModalOpen, setIsConfirmCancelModalOpen] =
    useState(false);

  return (
    <>
      <StyledSubscriptionSettingsPopover
        open={open}
        onClose={onClose}
        anchorEl={anchorEl}
        id={id}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <StyledSubscriptionSettingsPopoverContainer>
          <Stack direction="column" gap="8px" alignItems="flex-start">
            <StyledSubscriptionSettingsPopoverTitleBox
              as="button"
              onClick={(e) => {
                e.preventDefault();
                handleUpgradePlanClick();
                onClose();
              }}
            >
              <Text>Upgrade My Account</Text>
            </StyledSubscriptionSettingsPopoverTitleBox>
            <StyledSubscriptionSettingsPopoverTitleBox
              as="button"
              onClick={() =>
                setIsConfirmCancelModalOpen(!isConfirmCancelModalOpen)
              }
            >
              <Text>Cancel My Account</Text>
            </StyledSubscriptionSettingsPopoverTitleBox>
          </Stack>
        </StyledSubscriptionSettingsPopoverContainer>
      </StyledSubscriptionSettingsPopover>
      {isConfirmCancelModalOpen && (
        <ConfirmCancelModal
          isOpen={isConfirmCancelModalOpen}
          onClose={() => setIsConfirmCancelModalOpen(false)}
          onCancel={() => {
            setIsConfirmCancelModalOpen(false);
            onClose();
          }}
        />
      )}
    </>
  );
};
